import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import { createTheme } from '@material-ui/core/styles'
import { HashRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { client } from './services/apolloClient'
import ApplicationLayout from './components/ApplicationLayout'
import { customTheme } from './constants/theme'
import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import { options } from './constants/alerts'

const theme = createTheme(customTheme)

const App = () => {
  return (
    <ApolloProvider client={client}>
      <HashRouter>
        <ThemeProvider theme={theme}>
          <AlertProvider template={AlertTemplate} {...options}>
            <ApplicationLayout />
          </AlertProvider>
        </ThemeProvider>
      </HashRouter>
    </ApolloProvider>
  )
}

export default App
